import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface IExpansion {
    title: string;
    body: string;
}


@Component({
    selector: 'matmax-expansion',
    templateUrl: './expansion.component.html',
    styleUrls: ['./expansion.component.scss']
})
export class ExpansionComponent {
    @Input() data: IExpansion[];
    @Output() headerToggleFunc: EventEmitter<IExpansion> = new EventEmitter<IExpansion>();
    headerToggle(item: IExpansion) {
        this.headerToggleFunc.emit(item);
    }
    step = 0;

    setStep(index: number): void {
       this.step = index;
    }

    nextStep(): void {
       this.step++;
    }

    prevStep(): void {
       this.step--;
    }
}
